// extracted by mini-css-extract-plugin
export default {"melodyVideo":"eR-z","isFullWidth":"fR-z","landingPageVideo":"gR-z","play":"hR-z","iframeVideo":"iR-z","playHidden":"jR-z","fullwidth":"kR-z"};